module.exports = __webpack_public_path__ + "img/athletics_icon_8.04ac4ca0.png";